import constate from 'constate';
import { useState } from 'react';

export const useSubscribedSymbolsContext = constate(() => {
  const [subscribedQuotes, setSubscribedQuotes] = useState<string[]>([]);

  return [subscribedQuotes, setSubscribedQuotes] as [string[], typeof setSubscribedQuotes];
});
